import { api_get } from '../../util'

const state = {
  list: []
}

// getters
const getters = {
}

// actions
const actions = {
  fetchList ({commit}) {
    return new Promise ((resolve, reject) => {
      api_get('category').then(res => {
        commit('setList', res.data.sort((a, b) => a.name.localeCompare(b.name)))
        resolve(state.list)
      }).catch(err => {
        reject(err)
      })
    })
  },
  async fetchNutritionList ({commit, rootState}, category_id) {
    try {
      let res = await api_get(`category/${category_id}/nutritions`)
      commit('nutri/setList', res.data.map( nutri => {
        if (nutri.subname)
          nutri.name = `${nutri.name}(${nutri.subname})`
        return nutri
      }), {root: true})
    } catch (err) {
      console.log(err)
    }
  },
  async fetchBrandList ({commit, rootState}, category_id) {
    try {
      let res = await api_get(`category/${category_id}/brand`)
      commit('brand/setList', res.data.map( brand => {
        brand.name = `${brand.name}(${brand.count})`
        return brand
      }), {root: true})
    } catch (err) {
      console.log(err)
    }
  }
}

// mutations
const mutations = {
  setList (state, list) {
    state.list = list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/category.js